import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {BusinessCodeService, BusinessInfoService} from '../../../../services';
import {of, Subject, zip} from 'rxjs';
import {AngularFireDatabase} from 'angularfire2/database';
import set = Reflect.set;
import {GlnInfoDto} from '../../interface/gln-info.dto';
import {HttpClient} from "@angular/common/http";
import {Message} from "../../interface";

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy {
  feed: any;
  message: string;
  isBackground = true;
  list: GlnInfoDto[];
  // tslint:disable-next-line:variable-name
  public conversation_key = '';
  showChat = false;
  pageIndex = 1;
  pageSize = 50;
  total = 0;
  query;
  object = {};
  event;
  idPage
  detailConversations;
  client;
  // tslint:disable-next-line:variable-name
  load_gln = true;
  // @ts-ignore
  @ViewChild('listChat') listChat;
  // @ts-ignore
  @ViewChild('conversationChat') conversationChat;

  constructor(
    private  businessInfoService: BusinessInfoService,
    private businessCodeService: BusinessCodeService,
    private http: HttpClient
  ) {
  }

  unsubscribe$ = new Subject();

  ngOnInit() {
    this.loadGln();
    this.testGetDetailProduct().subscribe(console.log);
  }

  testGetDetailProduct() {
    return this.businessCodeService.getDetailProductByBarCode({key: '00000292492342'});
  }
  loadGln() {
    this.query = {
      page: this.pageIndex,
      page_size: this.pageSize
    };
    this.businessCodeService.getGlnOfChat(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe(
       res => {
        this.load_gln = false;
        this.list = res.data;
        if (res.code === 1) {
          this.selectGln(this.list[0]);
          const totalPage = Math.ceil(this.total / this.pageSize);
          if (this.pageIndex < totalPage) {
            this.pageIndex = this.pageIndex + 1;
            this.loadGln();
          }
        }
      },
      error => {
        this.load_gln = false;
      }
    );
  }
  removeUnread(valueSend) {
    this.listChat.removeUnread(valueSend);
  }
  clearConversation(data) {
    this.conversationChat.detailConversations = [];
  }
  reloadListChat(data) {
    const event = new GlnInfoDto();
    event.idPage = data;
    this.listChat.loadContent(event);
  }
 async loadDetailConversation(data: { conversations: Message[], client: {}}) {
   this.conversationChat.detailConversations = []
   data.conversations.reverse();
   for (const conversation of data.conversations) {
     if ( 'product' in conversation.message) {
       const detailProduct = await this.businessCodeService.
       getDetailProductByBarCode({key: conversation.message.product.barcode}).toPromise();
       console.log('detailProduct', detailProduct)
       if (detailProduct) {
         this.conversationChat.detailConversations.push({...conversation, detailProduct: detailProduct.items[0]});
         continue;
       }
     }
     this.conversationChat.detailConversations.push({...conversation, detailProduct: null});
   }
   this.conversationChat.client = data.client;
   this.conversationChat.owner = this.event;
   this.conversationChat.message = '';
  }

  validURL(str) {
    const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }

  selectGln(event) {
    this.conversationChat.owner = event;
    this.event = event;
    this.showChat = true;
    this.idPage = event.idPage;
    console.log(this.listChat.unsubscribe$Chat);
    if (this.listChat.unsubscribe$Chat) {
      this.listChat.unsubscribe$Chat.unsubscribe();
    }
    this.conversationChat.detailConversations = [];
    this.listChat.loadContent(event);
    // this.conversationChat.loadInfo(event);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
